import Script from 'next/script';

const isProd = process.env.NEXT_PUBLIC_FIREBASE_PROJECT_ID === 'sorra-4cd1f';

export const GoogleAnalyticsTracking = () => {
  return (
    <>
      {/* Global site tag (gtag.js) - Google Analytics */}
      <Script src="https://www.googletagmanager.com/gtag/js?id=G-WM58T2D95H" />
      <Script id="google-analytics" strategy="afterInteractive">
        {`
        window.dataLayer = window.dataLayer || [];
        function gtag(){window.dataLayer.push(arguments);}
        window.gtag = gtag;
        gtag('js', new Date());
        // 關掉自動 page_view，改由 _app 於換頁時手動送（可帶 brand_id 等參數）
        gtag('config', 'G-WM58T2D95H', { send_page_view: false });

        // extra gtag for Google Ads
        ${isProd ? 'gtag("config", "AW-361584336");' : ''}
        `}
      </Script>
    </>
  );
};
